import type { ComponentType } from "react";
import { useSearchParams } from "react-router";

type SearchParamKeyedRouteProps = {
  component: ComponentType;
  paramName: string;
};

export function SearchParamKeyedRoute({
  component: Component,
  paramName,
}: SearchParamKeyedRouteProps) {
  const [searchParams] = useSearchParams();
  const paramValue = searchParams.get(paramName) ?? "default";
  // Key ONLY on the tracked param so the page remounts when that param changes
  // (e.g. deep-linking to a different tab). Including `location.key` here would
  // rotate the key on *every* navigation — including a nested view writing an
  // unrelated search param — remounting the page and resetting its local tab
  // state to the default (SD-15484).
  return <Component key={paramValue} />;
}
